module.exports = __webpack_public_path__ + "img/incomeForecastGreen.a149eab5.png";